import React from 'react';
import { FormHelperText as ChakraFormHelperText, TextProps as ChakraFormHelperTextProps } from '@chakra-ui/react';

export function FormHelperText(props: ChakraFormHelperTextProps) {
  return (
    <ChakraFormHelperText
      fontFamily={'Ambit-Regular, Inter, sans-serif'}
      fontSize={'12px'}
      color={'typography.darkest'}
      {...props}
    />
  );
}
